import React, { Component } from 'react'
import { connect } from 'react-redux'
import Tooltip from 'react-tooltip'
import { holeHelper } from '../../helpers'

import { exportData } from '../../actions'
import { envConstants } from '../../constants'

const initialState = {
  name: ''
}

class Export extends Component {
  constructor() {
    super()
    this.state = initialState
  }

  callExport(exportType) {
    const lsf = window.localStorage.getItem(envConstants.ls.dashboard_form)
    if (lsf) {
      const lls = JSON.parse(lsf)
      const pq = holeHelper.formFilters(lls)
      this.props.exportData({
        locked: lls.selectedLocked,
        pq,
        exportType,
        name: this.state.name
      })
    }
  }

  render() {
    return (
      <>
        <Tooltip id='pdf' effect='solid'>
          PDF
        </Tooltip>
        <Tooltip id='csv' effect='solid'>
          CSV
        </Tooltip>
        <Tooltip id='xml' effect='solid'>
          XML
        </Tooltip>
        <div
          className='search-form-bkg'
          onClick={() => this.props.showExportForm()}
        ></div>
        <div className='search-form'>
          <h1>Esporta dati</h1>
          <label>Dai un nome a questa esportazione</label>
          <input
            type='text'
            placeholder='Nome esportazione'
            onChange={(event) => this.setState({ name: event.target.value })}
            value={this.state.name}
          />
          <ul className='list-export'>
            <li>
              <button
                className='lnk-export-holes'
                onClick={() => this.callExport('pdf')}
                data-tip=''
                data-for='pdf'
                disabled={this.state.name === ''}
              >
                <i className='fas fa-file-pdf'></i>
              </button>
            </li>
            <li>
              <button
                className='lnk-export-holes'
                onClick={() => this.callExport('csv')}
                data-tip=''
                data-for='csv'
                disabled={this.state.name === ''}
              >
                <i className='fas fa-file-csv'></i>
              </button>
            </li>
            <li>
              <button
                className='lnk-export-holes'
                onClick={() => this.callExport('xml')}
                data-tip=''
                data-for='xml'
                disabled={this.state.name === ''}
              >
                <i className='fas fa-file-code'></i>
              </button>
            </li>
          </ul>
          Il file verrà messo in coda e verrà scaricato automaticamente una
          volta pronto
        </div>
      </>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, { exportData })(Export)
